import React from 'react';
import Spinner, { SpinnerSize } from '../../shared/spinner/Spinner';

interface IOwnProps {
    type?: 'submit' | 'reset' | 'button';
    modifierClass?: string;
    disabled?: boolean;
    spinning?: boolean;
    onClick?: (e: React.FormEvent<HTMLButtonElement>) => void;
}

type Props = IOwnProps;

class Button extends React.Component<Props, {}> {
    public render() {
        return <button type={this.props.type} className={'button'.cAppend(this.props.modifierClass).cAppend(this.props.disabled, 'is-disabled').cAppend(this.props.spinning, 'is-spinning is-disabled')} disabled={this.props.disabled || this.props.spinning} onClick={this.handleClick}>
            <span className="text">{this.props.children}</span>
            {this.props.spinning && <span className="spin"><Spinner size={SpinnerSize.Small} /></span>}
        </button>;
    }

    private handleClick = (e: React.FormEvent<HTMLButtonElement>) => {
        e.persist();

        if (this.props.onClick) {
            this.props.onClick(e);
        }
    }
}

export default Button;